module.exports = __webpack_public_path__ + "img/block-1-1.c9d2d32e.png";